import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { VendorBO, GetListBO, WhereCondition, functionpermission } from './vendor.model';
import { VendorService } from './vendor.service';
import { vendorgridlist } from './vendordata.service';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})



// ====================================================exports===============================================================//
export class VendorComponent implements OnInit {

  public vendor: VendorBO = new VendorBO()
  VendorGridBO: GetListBO = new GetListBO();


  @ViewChild('grid') public grid: GridComponent;
  public data: Observable<DataStateChangeEventArgs>;
  private onDestroy$: Subject<void> = new Subject<void>();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  arraycol: any = [];


  VendorForm: FormGroup;
  form: FormGroup
  initialPage: object;
  filterOptions: FilterSettingsModel;
  public toolbar: ToolbarItems[];


  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  // ====================================================constructor============================================================//
  constructor(fb: FormBuilder, public general: GeneralService, public global: GlobalComponent,
    public vendorservice: VendorService, public toastrService: ToastrService,
    public commonhttp: CommonHttpService, @Inject(vendorgridlist) public gethttp: vendorgridlist,) {
    this.data = this.gethttp
    this.form = fb.group({
      zipCode: [''],
      phone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      email: ['', [Validators.required, Validators.email]],
    })
  }
  stateList: any = [];
  fp: functionpermission = new functionpermission()
  // =================================================================ngonit======================================================================//
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }

    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };

    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;

      this.getpermission()
    });

    this.getstatus();
    this.getVendorData();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Vendor");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.vendorservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  // ================================================formcreateupdate====================================================================//
  ModelType: string;
  CaseCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.vendor = new VendorBO();
      this.VendorForm.reset();
    }
    else {

      this.ModelType = 'edit';
    }

  }
  // =============================================================================================================================//
  editvendor(data) {

    this.vendor = JSON.parse(JSON.stringify(data));
    this.vendor.statusLid = this.statuslist.filter(s => s.id == data.statusLid)[0].id
  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  PhoneFormat(value) {
    if (value == 'phone') {
      this.vendor.phone = this.general.converPhoneGoogleLib(this.vendor.phone);
    }

  }


  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  valuechange: any = [];
  valueschanges() {
    this.valuechange = {
      Phone: 0

    }
  }
  checkpopup(value) {

    if (value == "phone") {
      this.valuechange.Phone++;
    }

  }

  openDialog() {
    if (this.valuechange.Phone) {
      document.getElementById('cancelcasemanmodal').click();
    }
    else {
      document.getElementById('opencasemanModal1').click();
    }

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  // =============================================================saveupdatevendor=================================================================//
  SaveVendor(type: string) {
    if (this.vendor.id == '00000000-0000-0000-0000-000000000000') {
      var saveList: VendorBO = JSON.parse(JSON.stringify(this.vendor));
      this.vendorservice.saveupdateVendor(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        this.toastrService.success("saved  Successfully", "vendor saved");
        document.getElementById("opencasemanModal1").click();

        this.getVendorData();
      },
        err => {
          this.toastrService.error(err.error);

        });
    }
    else {

      this.vendorservice.saveupdateVendor(this.vendor).subscribe((data: any) => {
        this.toastrService.success("update  Successfully", "vendor Updated ");
        document.getElementById("opencasemanModal1").click();

        this.getVendorData();
      },
        err => {
          this.toastrService.error(err.error);
        });
    }

  }

  // ==============================================deletevendor=======================================================================================//

  infoToast() {
    this.toastrService.error("Vendor is used in a purchase", "Unable to delete");
    setTimeout(() => {
      this.toastrService.clear()
    }, 8000);

  }

  deletedocId: string
  delete_vendor(data) {

    this.deletedocId = data.id
  }


  deleteVendor() {
    let params = new URLSearchParams();
    params.append("Id", this.deletedocId.toString());
    this.vendorservice.deleteVendor(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.toastrService.success(
          "Vendor  deleted successfully",
          "Vendor  Deleted",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
        document.getElementById("openModal2").click()
        this.getVendorData();
      }

    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(
          err.error,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  // ===================================================================vendorgrid==============================================//

  getVendorData() {
    this.gethttp.execute(this.VendorGridBO);
    let count = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      count = count + 1

    })
  }

  // ===============================================================================================================//
  statuslist: any
  getstatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.vendorservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.statuslist = data;
    })
  }

  // ==========================================================================================================================================//

  public onActionComplete(args) {
    this.VendorGridBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.VendorGridBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }

  // ================================================================================================================================//
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.VendorGridBO.orderColumn = state.sorted[0].name;
        this.VendorGridBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.VendorGridBO.field = state.action.currentFilterObject.field;
      this.VendorGridBO.matchCase = state.action.currentFilterObject.matchCase;
      this.VendorGridBO.operator = state.action.currentFilterObject.operator;
      this.VendorGridBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.VendorGridBO.field = "name";
        this.VendorGridBO.matchCase = false;
        this.VendorGridBO.operator = "startswith";
        this.VendorGridBO.value = "";
      }
    }
    this.getVendorData();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Vendor.Pagesize != state.take) {
          this.arraycol[0].vendor.Pagesize = state.take
        }

      }
    }
  }


  exportCsv() {
    this.vendorservice.getExportCsv().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Vendor Export";
      a.click();
    })

  }

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

    const byteCharacters = atob(b64Data);

    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {

      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {

        byteNumbers[i] = slice.charCodeAt(i);

      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);

    }

    const blob = new Blob(byteArrays, { type: contentType });

    return blob;

  }

}
